<div class="tpl3pl-page-container">
	<div class="tpl3pl-toolbar">
		<div class="tpl3pl-toolbar-filters">
			<mat-form-field appearance="fill" class="tpl3pl-field mr-2">
				<mat-label>Log Type</mat-label>
				<mat-select [(ngModel)]="logTypeFilter" (selectionChange)="loadLogs()">
					<mat-option value="">All</mat-option>
					<mat-option value="order_export">Order Export</mat-option>
					<mat-option value="shipment_import">Shipment Import</mat-option>
					<mat-option value="inventory_sync">Inventory Sync</mat-option>
					<mat-option value="error">Error</mat-option>
					<mat-option value="inbound">Inbound</mat-option>
				</mat-select>
			</mat-form-field>
			<mat-form-field appearance="fill" class="tpl3pl-field mr-2">
				<mat-label>Status</mat-label>
				<mat-select [(ngModel)]="statusFilter" (selectionChange)="loadLogs()">
					<mat-option value="">All</mat-option>
					<mat-option value="success">Success</mat-option>
					<mat-option value="error">Error</mat-option>
					<mat-option value="warning">Warning</mat-option>
				</mat-select>
			</mat-form-field>
			<mat-form-field appearance="fill" class="tpl3pl-field mr-2">
				<mat-label>Order Number</mat-label>
				<input
					matInput
					[(ngModel)]="ordernoFilter"
					(keyup.enter)="loadLogs()"
					placeholder="Filter by order number">
			</mat-form-field>
		</div>
		<div class="tpl3pl-toolbar-actions">
			<button mat-raised-button color="primary" (click)="loadLogs()">
			<mat-icon>refresh</mat-icon> Refresh
			</button>
		</div>
	</div>

	<div class="table-responsive position-relative tpl3pl-table-wrapper">
		<div *ngIf="loading" class="tpl3pl-loading-overlay">
			<mat-spinner diameter="48"></mat-spinner>
			<p class="mt-2 mb-0">Loading logs…</p>
		</div>
		<table mat-table [dataSource]="dataSource" class="w-100" matSort [class.tpl3pl-loading-opacity]="loading">
			<ng-container matColumnDef="created_at">
				<th mat-header-cell *matHeaderCellDef mat-sort-header>Timestamp</th>
				<td mat-cell *matCellDef="let item">{{ item.created_at | date:'short' }}</td>
			</ng-container>

			<ng-container matColumnDef="log_type">
				<th mat-header-cell *matHeaderCellDef>Type</th>
				<td mat-cell *matCellDef="let item">
					<span class="badge badge-secondary">{{ item.log_type }}</span>
				</td>
			</ng-container>

			<ng-container matColumnDef="orderno">
				<th mat-header-cell *matHeaderCellDef>Order/Item</th>
				<td mat-cell *matCellDef="let item">{{ item.orderno || item.stockid || '-' }}</td>
			</ng-container>

			<ng-container matColumnDef="direction">
				<th mat-header-cell *matHeaderCellDef>Direction</th>
				<td mat-cell *matCellDef="let item">
					<span class="badge" [ngClass]="{'badge-info': item.direction === 'inbound', 'badge-primary': item.direction === 'outbound'}">
						{{ item.direction }}
					</span>
				</td>
			</ng-container>

			<ng-container matColumnDef="status">
				<th mat-header-cell *matHeaderCellDef>Status</th>
				<td mat-cell *matCellDef="let item">
					<mat-icon [ngClass]="getStatusColor(item.status)" [matTooltip]="getStatusLabel(item.status)">{{ getStatusIcon(item.status) }}</mat-icon>
				</td>
			</ng-container>

			<ng-container matColumnDef="message">
				<th mat-header-cell *matHeaderCellDef>Message</th>
				<td mat-cell *matCellDef="let item" class="message-cell" [matTooltip]="item.message" matTooltipPosition="above">
					<span class="message-truncate">{{ item.message }}</span>
				</td>
			</ng-container>

			<ng-container matColumnDef="error_details">
				<th mat-header-cell *matHeaderCellDef>Error Details</th>
				<td mat-cell *matCellDef="let item">
					<button *ngIf="item.error_details" mat-icon-button (click)="showErrorDetails(item)" matTooltip="View error details">
						<mat-icon>info</mat-icon>
					</button>
				</td>
			</ng-container>

			<ng-container matColumnDef="actions">
				<th mat-header-cell *matHeaderCellDef>Actions</th>
				<td mat-cell *matCellDef="let item">
					<button *ngIf="item.request_data != null || item.response_data != null" mat-icon-button (click)="showRequestResponse(item)" matTooltip="View request/response">
						<mat-icon>code</mat-icon>
					</button>
				</td>
			</ng-container>

			<tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
			<tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
			<tr class="mat-row" *matNoDataRow>
				<td class="mat-cell text-center text-muted py-4" [attr.colspan]="displayedColumns.length">No log entries.</td>
			</tr>
		</table>

		<mat-paginator [pageSizeOptions]="[10, 25, 50, 100]"></mat-paginator>
	</div>
</div>
